import { render, staticRenderFns } from "./collectionProductList.vue?vue&type=template&id=9280dca8"
import script from "./collectionProductList.vue?vue&type=script&lang=js"
export * from "./collectionProductList.vue?vue&type=script&lang=js"
import style0 from "./collectionProductList.vue?vue&type=style&index=0&id=9280dca8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports